export default "__VITE_ASSET__DzUFvDoH__"